import { PRODUCT_NAME_MAX_LENGTH } from '@entities/product/api/product.contract'

export const productNameRequiredMessage = 'Informe um nome para identificar o produto.'
export const productNameLengthMessage = `Use no máximo ${PRODUCT_NAME_MAX_LENGTH} caracteres no nome do produto.`

export function validateProductName(value: string): string | undefined {
  if (!value.trim()) return productNameRequiredMessage
  return value.length > PRODUCT_NAME_MAX_LENGTH ? productNameLengthMessage : undefined
}
